export default function Marketplace(){
    return(
        <div className={"px-4 relative container mx-auto"}>
            <h2 className={"text-xl py-2 font-bold flex flex-row items-center"}>
                <hr className={"mr-2 flex-grow border border-white/40 bg-white/40"} />
                <span>Marketplace</span>
                <hr className={"ml-2 flex-grow border border-white/40 bg-white/40"} />
            </h2>
        </div>
    )
}